import { Action } from "@ngrx/store";

import { Home } from "@intocare/interfaces";

export const SET_HOMES = "[Homes] Set homes";
export const UPDATE_HOME = "[Homes] Update home";
export const UPDATE_HOME_PHARMACIES = "[Homes] Update pharmacies of a home";

export class SetHomes implements Action {
	readonly type = SET_HOMES;

	payload: {
		data: Home[];
	};

	constructor(data: Home[]) {
		this.payload = {
			data,
		};
	}
}

export class UpdateHome implements Action {
	readonly type = UPDATE_HOME;

	payload: {
		data: Home;
	};

	constructor(data: Home) {
		this.payload = {
			data,
		};
	}
}

export class UpdateHomePharmacies implements Action {
	readonly type = UPDATE_HOME_PHARMACIES;

	payload: {
		data: {
			id: string;
			licenseNumber: string;
		};
	};

	constructor(data: { id: string; licenseNumber: string }) {
		this.payload = {
			data,
		};
	}
}

export type Actions = SetHomes | UpdateHome | UpdateHomePharmacies;
